// RetreatState import removed due to no-op visibility handler
export type ManagerLike = {
  pause?: () => Promise<void> | void;
  resume?: () => Promise<void> | void;
  stop?: () => Promise<void> | void;
  getState?: () => string;
};

/**
 * Create a visibility handler bound to a manager supplier.
 *
 * DESIGN DECISION: This handler ONLY pauses and resumes.
 * It does NOT compute sync offsets or call manager.sync().
 *
 * Why? The HeartbeatManager has its own visibilitychange listener
 * that calls _reconcile() using Date.now() wall-clock anchor math.
 * That is the correct, single source of timing truth.
 *
 * Previous bug: This handler computed sync offset from performance.now()
 * delta + getActiveSession().progress (which was always 0), resetting
 * the timer to near-zero on every tab switch.
 */
export function createVisibilityHandler(_getManager: () => ManagerLike | null) {
  return function handleVisibility() {
    // DESIGN DECISION: Do absolutely nothing on visibility change!
    //
    // The "Engine Hardening" sprint introduced the ObjectiveClock (Web Worker).
    // Its explicit purpose is to keep ticking when the tab is backgrounded
    // (the "Pocket Test").
    //
    // Previous bug: Pausing the engine here caused HeartbeatManager to freeze
    // its anchor time (`_accumulatedPauseOffsetMs`), meaning any time spent in
    // the background was completely ignored by the meditation timer!
    //
    // The engine's continuous background execution will now correctly advance
    // time, play scheduled bells, and auto-persist to IndexedDB.
  };
}

export function createStopHandler(getManager: () => ManagerLike | null) {
  return function handleStop() {
    const manager = getManager();
    if (!manager) return;
    try {
      manager.stop?.();
    } catch (e) {
      console.debug("stopHandler.stop failed", e);
    }
  };
}
